"use client";

import { Toaster } from "@/components/ui/sonner";

export default function SonnarToaster() {
  return <Toaster richColors position="top-right" duration={2000} />;
}
